// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import Language from "@material-ui/icons/Language";

// New @material-ui/icons
import PeopleAltIcon from "@material-ui/icons/PeopleTwoTone";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import WorkIcon from "@material-ui/icons/Work"

// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
// import UserProfile from "views/UserProfile/UserProfile.js";
import Academic from "views/AcademicInformation";
import Autobiography from "views/Autobiography";
import Occupation from "views/Occupation";
import OlevelCertificate from "views/OlevelCertificate";
import ParentGuardian from "views/ParentGuardian";
import Personal from "views/Personal";
import UserProfile from "views/UserProfile/UserProfile";
import UploadDocument from "views/UploadDocument/UploadDocument";

// import TableList from "views/TableList/TableList.js";
// import Typography from "views/Typography/Typography.js";
// import Icons from "views/Icons/Icons.js";
// import Maps from "views/Maps/Maps.js";
// import NotificationsPage from "views/Notifications/Notifications.js";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";


const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/apply"
  },
  {
    path: "/personal-information",
    name: "Personal Information",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Person,
    component: Personal,
    layout: "/apply"
  },
  {
    path: "/academic-information",
    name: "Academic Information",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: Academic,
    layout: "/apply"
  },
  {
    path: "/parent-guardian",
    name: "Parent / Guardian Info",
    rtlName: "طباعة",
    icon: PeopleAltIcon,
    component: ParentGuardian,
    layout: "/apply"
  },
  {
    path: "/certificate",
    name: "Certificates",
    rtlName: "خرائط",
    icon: LibraryBooksIcon,
    component: OlevelCertificate,
    layout: "/apply"
  },
  {
    path: "/upload-document",
    name: "Upload Document",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: UploadDocument,
    layout: "/apply"
  },
  {
    path: "/occupation",
    name: "Occupation / Infomation",
    rtlName: "إخطارات",
    icon: WorkIcon,
    component: Occupation,
    layout: "/apply"
  },
  {
    path: "/autobiography",
    name: "Autobiography",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: Autobiography,
    layout: "/apply"
  },
  {
    path: "/user",
    name: "User Profile",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: UserProfile,
    layout: "/apply"
  }
];

export default dashboardRoutes;
